import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {TextCharLimit, Stack, Box, Typography, Button, Paper, Divider} from 'views/components';

import {translate, Translate, MarkdownEditor} from 'views/module';
import {useNavigate} from 'views/module';

import backend from 'utils/backend';

const DEFAULT_CLIENT_DATA = {
  clientLeadName: '',
  description: {
    blob: '',
    editorType: 'MARKDOWN',
  },
};

const NewClientLead = (props) => {
  const [newClientLeadData, setNewClientLeadData] = React.useState(DEFAULT_CLIENT_DATA);
  const [newClientLeadDataValid, setNewClientLeadDataValid] = React.useState(false);

  const navigate = useNavigate();

  const progressWrap = props.statusProgressWrap;

  const clientLeadName = newClientLeadData.clientLeadName || '';
  const description = newClientLeadData?.description?.blob || '';

  const setclientLeadName = (newValue) => {
    setNewClientLeadData((e) => {
      return {
        ...e,
        clientLeadName: newValue,
      };
    });
  };
  const setDescription = (newValue) => {
    setNewClientLeadData((e) => {
      return {
        ...e,
        description: {
          blob: newValue,
          editorType: 'MARKDOWN',
        },
      };
    });
  };

  React.useEffect(() => {
    setNewClientLeadDataValid(Boolean(clientLeadName));
  }, [clientLeadName]);

  const isSubmitDisabled = () => {
    return !newClientLeadDataValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    progressWrap(async () => {
      const result = await backend.clientLead.createClientLead(newClientLeadData);

      navigate(`/client_lead/${result.clientLeadRn}`);
    });
  };

  return (
    <Paper sx={{p: {xs: 1, md: 2}}}>
      <Stack direction='column' spacing={2} wrap='nowrap'>
        <Box>
          <Typography variant='h4' sx={{fontWeight: 500}}>
            <Translate expression='clientLead.ClientLeadNew.Title' />
          </Typography>
        </Box>
        <Divider variant={'middle'}/>
        <Box>
          <TextCharLimit
            label={translate('clientLead.ClientLeadNew.ClientLeadName')}
            value={clientLeadName}
            onChange={setclientLeadName}
            charLimit={180}
          />
        </Box>
        <Stack spacing={1}>
          <Box sx={{display: 'flex', alignContent: 'left'}}>
            <Typography variant='description1' sx={{fontWeight: 500}}>
              <Translate expression='clientLead.ClientLeadNew.ClientLeadDescription' />
            </Typography>
          </Box>
          <Box xs={12}>
            <MarkdownEditor
              value={description}
              onChange={setDescription}
            />
          </Box>
        </Stack>
        <Box>
          <Stack>
            <Button
              color={'primary'}
              disabled={isSubmitDisabled()}
              onClick={handleSubmit}
              label={translate('clientLead.ClientLeadNew.CreateNewClientLead')}
              sx={{
                p: '8px 22px 8px 22px',
              }}
            />
            <Button
              variant='text'
              href='/clientLead'
              label={translate('generic.Cancel')}
              sx={{
                'textTransform': 'none',
                'textDecoration': 'underline',
                'fontSize': '12px',
                'fontWeight': 'bold',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}/>
          </Stack>
        </Box>
      </Stack>
    </Paper>
  );
};

NewClientLead.propTypes = {
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(NewClientLead));
